import { useContext } from "react";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../../../routes/AllRoutes";
import RootState from "../../../../../redux/type";
import ActionContext from "../../../../../context/ActionContext";
// import ReuseModal from "../../../components/fragment/modal/ReuseModal";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  details?: any;
}

const EndSessionTokenModal = ({
  onClose,
  visible,
  details,
}: myComponentProps) => {
  const actionCtx = useContext(ActionContext);
  const { loading_logout } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    localStorage.clear();
    // navigate(ALL_ROUTES?.LOGIN);
    setTimeout(() => {
      window.location.replace(ALL_ROUTES?.LOGIN);
    }, 1000);
    actionCtx?.setSessionEnd && actionCtx?.setSessionEnd(false);
  };

  return (
    <>
      <ReuseModal
        hideClose
        visible={visible}
        // onClose={handleClose}
        deleteType
        // loading={loading_logout}
        onBtnClick={handleSubmit}
        hideCancel
        btnColor="black-light"
        btnLabel="Proceed to login"
        title="Session Expired"
        deleteText='Please we notice your token has expired, kindly click on "Proceed to login to refresh token."'
      />
    </>
  );
};

export default EndSessionTokenModal;
